import { render, staticRenderFns } from "./PeriodDropdown.vue?vue&type=template&id=74bf8c2e&"
import script from "./PeriodDropdown.vue?vue&type=script&lang=js&"
export * from "./PeriodDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports